import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import { TranslateCustomTemplateResponse } from 'models/automation/CustomTemplates';
import API from 'services/API';

export const TRANSLATE_CUSTOM_TEMPLATE_MUTATION_KEY =
  'translate-custom-template';

type TranslateCustomTemplatePayload = {
  templateUid: string;
  sourceLanguage: string;
  targetLanguage: string;
};

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    unknown,
    BaseErrorResponse,
    TranslateCustomTemplatePayload,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const translateCustomTemplate = (payload: TranslateCustomTemplatePayload) => {
  const { templateUid } = payload;

  return API.post<TranslateCustomTemplateResponse>(
    `/api/internal/automation/templates/translation/${templateUid}/translate`,
    payload,
  );
};

const useTranslateCustomTemplateMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationKey: [TRANSLATE_CUSTOM_TEMPLATE_MUTATION_KEY],
    mutationFn: translateCustomTemplate,
    ...options,
  });
};

export default useTranslateCustomTemplateMutation;
